export interface OddsInput {
  Odds: OddItem[];
}

export interface OddItem {
  ItemId: number;
  Odds: number;
  BaseOdds?: number;
}
